import { render, staticRenderFns } from "./nameEdit.vue?vue&type=template&id=3818dcf2&scoped=true&"
import script from "./nameEdit.vue?vue&type=script&lang=ts&"
export * from "./nameEdit.vue?vue&type=script&lang=ts&"
import style0 from "./nameEdit.vue?vue&type=style&index=0&id=3818dcf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818dcf2",
  null
  
)

export default component.exports